import { fetchAndActivate, getAll, Value } from "firebase/remote-config";
import React, { ReactNode } from "react";
import {
  FirebaseRemoteConfigContext,
  remoteConfig,
} from "./useFirebaseRemoteConfig.shared";

// Only for development
remoteConfig.settings.minimumFetchIntervalMillis = 3600000;

remoteConfig.defaultConfig = {
  supplierProductListV2: import.meta.env.VITE_ENV === "development",
};

export const FirebaseRemoteConfigProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [flags, setFlags] = React.useState<{
    [key: string]: string | number | boolean | Value;
  }>(remoteConfig.defaultConfig);

  React.useEffect(() => {
    fetchAndActivate(remoteConfig)
      .then((activated) => {
        if (!activated) console.log("not activated");
        return getAll(remoteConfig);
      })
      .then((remoteFlags) => {
        setFlags((currentFlags) => {
          const newFlags = { ...currentFlags };

          for (const [key, config] of Object.entries(remoteFlags)) {
            newFlags[key] = config.asBoolean();
          }

          return newFlags;
        });
      })
      .catch((error) => console.error(error));
  }, []);

  return (
    <FirebaseRemoteConfigContext.Provider value={flags}>
      {children}
    </FirebaseRemoteConfigContext.Provider>
  );
};
